/*
 * This variable is automatically overwritten during builds and releases.
 * It doesn't need to be updated manually.
 */

/**
 * MoJ Frontend release version
 *
 * {@link https://github.com/ministryofjustice/moj-frontend/releases}
 */
export const version = 'development'
